/* eslint-disable */
import React, { useEffect, useState } from "react";
import Page from "./Page";
import { useDispatch, useSelector } from "react-redux";
import {
  resetCurrentFeedbackScore,
  setCurrentPage,
  setSessionId,
} from "Redux/actions";
import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";
import { omit } from "lodash";
import PageLoader from "./PageLoader";

const Widget = React.memo(() => {
  const { loading = false, data = {} } = useSelector(
    (state) => state.widgetJSON
  );

  const { scroll } = useSelector((state) => state);

  const uid = useSelector((state) => state.uid);
  const maxPage = useSelector((state) => state.maxPage);
  const sessionId = useSelector((state) => state.sessionId);
  const [sessionIdExsists, setSessionIdExsists] = useState(false);
  const dispatch = useDispatch();
  const { is_kiosk_mode = false } = data.general_settings || {};

  useEffect(() => {
    setScroll(scroll);
  }, [scroll]);

  const setScroll = (scroll) => {
    const body = document.querySelector("body");
    body.style.overflow = scroll ? "auto" : "hidden";
  };

  useEffect(() => {
    const cookiesSession = Cookies.get("sessions") || JSON.stringify({});
    const sessions = JSON.parse(cookiesSession);

    if (!sessions[uid]) {
      const uniqueId = uuidv4();
      dispatch(setSessionId({ sessionId: uniqueId, sessions }));
    } else if (sessions[uid] && is_kiosk_mode) {
      const {
        sessionId = "",
        feedbackScore = 0,
        selectedLanguage = "",
        rate = "positive",
      } = sessions[uid];

      const newSessions = omit(sessions, [uid]);

      Cookies.set("sessions", JSON.stringify(newSessions));

      dispatch(setSessionId({ sessionId, sessions, rate }, selectedLanguage));
      dispatch(resetCurrentFeedbackScore(feedbackScore));
      dispatch(setCurrentPage(maxPage + 1));
    } else {
      const {
        sessionId = "",
        feedbackScore = 0,
        selectedLanguage = "",
        rate,
      } = sessions[uid];
      setSessionIdExsists(true);
      dispatch(setSessionId({ sessionId, sessions, rate }, selectedLanguage));
      dispatch(resetCurrentFeedbackScore(feedbackScore));
      dispatch(setCurrentPage(maxPage + 1));
    }
  }, []);

  return !loading && sessionId ? <Page /> : <PageLoader />;
});

export default Widget;
